import { Component, EventEmitter, Inject, Input, OnInit, Output, LOCALE_ID, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SettingValueModel, UserSettingModel } from 'src/app/Modules/settings/models/informate';
import { LayoutService } from 'src/app/RefModules/_metronic/core';
import { ManagementApiService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ErrorDialogComponent } from 'src/app/shared/info-dialogs/error-dialog/error-dialog.component';

@Component({
    selector: 'app-units',
    templateUrl: './units.component.html',
    styleUrls: ['./units.component.scss'],
})
export class UnitsComponent implements OnInit {
    @Input() showPanelUnitToggle;
    @Output() hideUnitpanel = new EventEmitter();

    extrasQuickPanelOffcanvasDirectionCSSClass = 'offcanvas-right';
    activeTabId: 'kt_quick_panel_logs' | 'kt_quick_panel_notifications' | 'kt_quick_panel_settings' = 'kt_quick_panel_logs';
    profileSettingAreaId: string;
    userSettings: UserSettingModel[];
    defaultUnitSettings: UserSettingModel[];
    defaultAllOption: UserSettingModel;
    defaultUnitOptions: UserSettingModel[];
    defaultUnitMetric: boolean;
    defaultUnitImperial: boolean;
    public informateSettingsForm: FormGroup;
    dataSource: any = [];
    optValArray: any[] = [];

    private internalDataMap: any[];
    constructor(
        @Inject(LOCALE_ID) public locale: string,
        private layout: LayoutService,
        private mgmtApi: ManagementApiService,
        private user_utility: UserUtilityService,
        private fb: FormBuilder,
        private cd: ChangeDetectorRef,
        private customToastService: CustomToastService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private globalEmitterService: GlobalEmittersService,
        private modelService: NgbModal
    ) {}

    ngOnInit(): void {
        this.extrasQuickPanelOffcanvasDirectionCSSClass = `offcanvas-${this.layout.getProp('extras.quickPanel.offcanvas.direction')}`;
        this.getSettings();
        if (!this.dataSource?.length) return;
    }

    closetoggle() {
        this.hideUnitpanel.emit();
    }

    initialise(): void {
        this.defaultAllOption = this.dataSource.find((item) => {
            return item.setting.key.toLowerCase() === 'defaultunits';
        });

        this.defaultUnitOptions = this.dataSource.filter((item) => {
            return item.setting.key.toLowerCase() !== 'defaultunits';
        });

        this.internalDataMap = this.defaultUnitOptions.reduce((prev, { setting, settingValue }) => {
            const key = setting.key;
            const ordinal = settingValue.ordinal;
            prev.push({ key, ordinal });
            return prev;
        }, []);

        this.defaultUnitMetric = this.internalDataMap.every((opt) => opt.ordinal === 0); //this.defaultAllOption.settingValue.value.toLowerCase() === 'metric'
        this.defaultUnitImperial = this.internalDataMap.every((opt) => opt.ordinal === 1); //this.defaultAllOption.settingValue.value.toLowerCase() === 'imperial'

        this.defaultUnitOptions.forEach((x) => {
            this.optValArray.push({ key: x.setting.key, val: this.extractOptions(x.setting.settingValues) });
        });
    }

    trackById(index, item) {
        return item.setting.settingId;
    }

    extractOptions(options: SettingValueModel[]) {
        return options.map((item) => ({
            label: item.abbreviation ?? item.value,
            value: item.settingValueId,
        }));
    }

    getOtionbyKeys(key) {
        return this.optValArray.find((x) => x.key == key).val;
    }

    onRadioChange(selectedValue: string) {
        const option = this.defaultUnitOptions.find((item) => item.setting.settingValues.some((opts) => opts.settingValueId === selectedValue));

        if (!option) return;

        const originalSetting = this.defaultUnitOptions.find((y) => y.setting.key === option.setting.key);
        const ordinalTarget = option.setting.settingValues.find((x) => x.settingValueId === selectedValue)?.ordinal;

        this.updateInternalDataMap(option.setting.key, ordinalTarget);

        this.defaultUnitMetric = this.internalDataMap.every((opt) => opt.ordinal === 0);
        this.defaultUnitImperial = this.internalDataMap.every((opt) => opt.ordinal === 1);

        this.controlStateUpdate(option.setting.key, originalSetting.settingValue.ordinal.toString(), ordinalTarget.toString());
    }

    changeDefault($event: MatSlideToggleChange) {
        const defaultOptionsSettingValues = this.defaultAllOption.setting.settingValues;

        switch ($event.source.name) {
            case 'metric':
                this.defaultUnitMetric = $event.checked;
                this.defaultUnitImperial = !$event.checked;
                this.updateDefaultUnitSetting(
                    defaultOptionsSettingValues.find((option) => option.value.toLowerCase() === ($event.checked ? 'metric' : 'imperial'))
                );
                break;
            case 'imperial':
                this.defaultUnitImperial = $event.checked;
                this.defaultUnitMetric = !$event.checked;
                this.updateDefaultUnitSetting(
                    defaultOptionsSettingValues.find((option) => option.value.toLowerCase() === ($event.checked ? 'imperial' : 'metric'))
                );
                break;
            default:
        }

        this.swtichDefaultStates();
    }

    swtichDefaultStates() {
        const ordinalTarget = this.defaultUnitMetric ? 0 : 1;
        this.defaultUnitOptions.forEach((item) => {
            const key = item.setting.key;
            this.informateSettingsForm.get(key).setValue(item.setting.settingValues.find((option) => option.ordinal === ordinalTarget).settingValueId);
            this.controlStateUpdate(key, item.settingValue.ordinal.toString(), ordinalTarget.toString());
            this.updateInternalDataMap(key, ordinalTarget);
        });
    }

    updateDefaultUnitSetting(settingValue: SettingValueModel) {
        const originalSetting = this.defaultAllOption.settingValue;
        this.informateSettingsForm.get('DefaultUnits').setValue(settingValue.settingValueId);
        this.controlStateUpdate('DefaultUnits', originalSetting.settingValueId.toLowerCase(), settingValue.settingValueId.toLowerCase());
    }

    updateInternalDataMap(key: string, ordinal: number) {
        const dataMapIdx = this.internalDataMap.findIndex((x) => x.key === key);
        this.internalDataMap[dataMapIdx] = { key, ordinal };
    }

    controlStateUpdate(key: string, originalValue: string, newValue: string): void {
        if (originalValue !== newValue) {
            this.informateSettingsForm.get(key).markAsDirty();
            this.informateSettingsForm.get(key).markAsTouched();
        } else {
            this.informateSettingsForm.get(key).markAsPristine();
        }
    }

    getSettings(): void {
        this.ngxUiLoaderService.start();
        this.mgmtApi.getSettingProfileAreaId('informate').subscribe((res) => {
            if (res.success === true) {
                this.profileSettingAreaId = res.response.settingAreaId;
                if (this.profileSettingAreaId) {
                    this.mgmtApi.getSettingbySettinfAreaId(this.profileSettingAreaId).subscribe((userSettings) => {
                        if (userSettings.success === true) {
                            this.userSettings = userSettings.response;
                            this.defaultUnitSettings = this.getSectionData('Defaults', false);
                            this.dataSource = this.defaultUnitSettings;
                            this.buildForm();
                            this.initialise();
                            this.cd.markForCheck();
                        } else {
                            this.user_utility.errorModelPopup(userSettings.message);
                        }
                        this.ngxUiLoaderService.stop();
                    });
                }
            } else {
                this.ngxUiLoaderService.stop();
                this.user_utility.errorModelPopup(res.message);
            }
        });
    }

    buildForm(): void {
        this.informateSettingsForm = null;
        this.informateSettingsForm = this.fb.group({});

        this.defaultUnitSettings.forEach((obj, index) => {
            const validatorsToAdd = [];

            if (obj.setting.isRequired) {
                validatorsToAdd.push(Validators.required);
            }

            this.informateSettingsForm.addControl(obj.setting.key, this.fb.control(this.getFormStateValue(obj), validatorsToAdd));
        });
    }

    getSectionData(sectionName: string, isSubSection: boolean = false): UserSettingModel[] {
        const sections: UserSettingModel[] = this.userSettings.filter((item: UserSettingModel) => {
            if (isSubSection) {
                return item.setting.settingSubSection?.name.toLowerCase() === sectionName.toLowerCase();
            }

            return item.setting.settingSubSection?.settingSection.name.toLowerCase() === sectionName.toLowerCase();
        });
        return sections;
    }

    getFormStateValue(userSetting: UserSettingModel) {
        if (userSetting.value) {
            return userSetting.value;
        }

        if (userSetting.settingValue) {
            return userSetting.settingValue.settingValueId;
        }

        return null;
    }

    formConsole() {}

    async saveSettingsOutputHandler() {
        // informate form...
        if (this.informateSettingsForm.dirty) {
            const updateJson = [];

            Object.keys(this.informateSettingsForm.controls).forEach((key) => {
                const ctrl: AbstractControl = this.informateSettingsForm.controls[key];
                const json = {};

                if (ctrl.dirty && ctrl.valid) {
                    const userSetting: UserSettingModel = this.userSettings.find((item) => item.setting.key === key);

                    if (userSetting) {
                        json['userSettingId'] = userSetting.userSettingId;
                        json['userId'] = userSetting.userId;
                        json['settingId'] = userSetting.setting.settingId;
                        if (userSetting.settingValue) {
                            json['settingValueId'] = ctrl.value; //userSetting.settingValue.settingValueId
                        } else if (userSetting.value) {
                            json['value'] = ctrl.value; //userSetting.value
                        }

                        updateJson.push(json);
                    }
                }
            });

            // update mgmt service!
            if (updateJson.length !== 0) {
                await this.updateSettingsInformate(updateJson);
            }
        }
    }

    async updateSettingsInformate(updateJson) {
        this.ngxUiLoaderService.start();
        await this.mgmtApi.updateUserSettings(updateJson).subscribe(async (result) => {
            if (result.success === true) {
                this.customToastService.successToast('User settings updated!', 'Success');
                this.informateSettingsForm.reset(this.informateSettingsForm.value);
                await this.getSettings();
                const userDefaultRes = await this.mgmtApi.getUserDefaults().toPromise();
                if (userDefaultRes.success) {
                    this.mgmtApi.userDefaults = userDefaultRes.response;
                    this.globalEmitterService.unitUpdated.next(true);
                } else if (userDefaultRes.isCustom) {
                    this.user_utility.errorModelPopup(userDefaultRes.message);
                }
                this.ngxUiLoaderService.stop();
            } else {
                let dialogRef = this.modelService.open(ErrorDialogComponent);
                dialogRef.componentInstance.message = result.message;
                this.ngxUiLoaderService.stop();
            }
        });
    }
}
